import { Formik, Form } from 'formik';
import React from 'react';
import { PropTypes } from 'prop-types';
import { ClinicInput, SubmitButton } from '../UI';
import { useContext } from 'react';
import MessagesContext from '../../contexts/messagesContext';
import { styles } from './styles';

const ProfileForm = ({ initialValues, validation, inputs, handleSubmit }) => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);

    return (
        <>
            <Formik
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting }) => (
                    <Form>
                        {inputs.map((input, index) => (
                            <div key={index}>
                                <ClinicInput
                                    name={input.name}
                                    label={input.label}
                                    type={input.type}
                                    autoFocus={input.name === 'username'}
                                    dir="auto"
                                    width="100%"
                                    isPassword={input?.isPassword}
                                />
                            </div>
                        ))}
                        <div className={classes.buttonContainer}>
                            <SubmitButton
                                isSubmitting={isSubmitting}
                                submitText={messages.save}
                                width="120"
                                mr="0"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
};
ProfileForm.propTypes = {
    initialValues: PropTypes.object,
    validation: PropTypes.any,
    inputs: PropTypes.array,
    handleSubmit: PropTypes.func
};
export default ProfileForm;
